/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import * as ApiService from './ApiService';

const baseUrl = 'utilities/';

export function softInitLineItem(data) {
    return ApiService.post(true, `${baseUrl}documents/softInitLineItem`, data);
}

export function softAdjustLineItems(data) {
    return ApiService.post(
        true,
        `${baseUrl}documents/softAdjustLineItems`,
        data
    );
}

export function getFinancialSync(model, id) {
    return ApiService.get(true, `${baseUrl}financialSync/${model}/${id}`);
}

export function createFinancialSync(model, id) {
    return ApiService.post(true, `${baseUrl}financialSync/${model}/${id}`, {});
}

export function calculateLineItemCost(data) {
    return ApiService.post(
        true,
        `${baseUrl}documents/calculateLineItemCost`,
        data
    );
}

export function featureFlag(feature) {
    return ApiService.get(true, `${baseUrl}/featureFlag?feature=${feature}`);
}
